import { useCallback, useState } from "react";
import { Pressable, StyleSheet, TextInput } from "react-native";

import { Col, Icon, Row, Spinner } from "../lib";
import { colors, createStyles } from "../theme";

type Props = {
  disabled?: boolean;
  loading?: boolean;
  onChange?: (text: string) => void;
  onSubmit?: (text: string) => void;
  placeholder?: string;
};

export function Composer({
  disabled = false,
  loading = false,
  onChange,
  onSubmit,
  placeholder = "Type a message...",
}: Props) {
  // State
  const [text, setText] = useState("");

  // Handlers
  const handleChange = (text: string) => {
    if (text.length <= 191) {
      setText(text);
    }

    onChange?.(text);
  };

  const handleSubmit = useCallback(() => {
    if (text) {
      onSubmit?.(text);
      setText("");
    }
  }, [text, onSubmit]);

  return (
    <Row style={$.container}>
      <TextInput
        editable={!disabled && !loading}
        placeholder={placeholder}
        onChangeText={handleChange}
        style={$.textInput}
        returnKeyType="send"
        value={text}
      />
      <Col mr="2">
        <Pressable disabled={disabled || loading} onPress={handleSubmit}>
          {loading ? (
            <Spinner em />
          ) : (
            <Icon em={!disabled} name="arrow-right" />
          )}
        </Pressable>
      </Col>
    </Row>
  );
}

const $ = createStyles({
  container: {
    row: 4,
    backgroundColor: "surface",
    borderTopColor: colors.outline,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  disabled: {
    opacity: 0.5,
  },
  textInput: {
    p: "4",
    flex: 1,
    color: "onSurface",
  },
});
